// extracted by mini-css-extract-plugin
export default {"icon":"AIAssistantContextMenu_icon__8pgzn","iconButton":"AIAssistantContextMenu_iconButton__XgnTU","loadingIconWrapper":"AIAssistantContextMenu_loadingIconWrapper__gW69C"};